<template>
  <div class="content">
    <div class="container-fluid">
      <!-- Header -->
      <div class="row">
        <div class="col-12">
          <div class="card trainer-evaluations-header">
            <div class="card-header trainer-card-header">
              <div class="row align-items-center">
                <div class="col-sm-6">
                  <h4 class="card-title trainer-title">
                    <i class="nc-icon nc-paper"></i>
                    Evaluaciones y Tests
                  </h4>
                  <p class="card-category trainer-subtitle">
                    Gestiona evaluaciones físicas y seguimiento de progreso
                  </p>
                </div>
                <div class="col-sm-6 text-right">
                  <button class="btn btn-light trainer-btn-new" @click="showNewEvaluationModal = true">
                    <i class="nc-icon nc-simple-add"></i>
                    Nueva Evaluación
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Estadísticas -->
      <div class="row">
        <div class="col-lg-3 col-md-6">
          <div class="card card-stats trainer-stats-card">
            <div class="card-body">
              <div class="row">
                <div class="col-5">
                  <div class="icon-big text-center">
                    <i class="nc-icon nc-paper text-primary"></i>
                  </div>
                </div>
                <div class="col-7">
                  <div class="numbers">
                    <p class="card-category">Total Evaluaciones</p>
                    <p class="card-title trainer-number">{{ evaluations.length }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-lg-3 col-md-6">
          <div class="card card-stats trainer-stats-card">
            <div class="card-body">
              <div class="row">
                <div class="col-5">
                  <div class="icon-big text-center">
                    <i class="nc-icon nc-calendar-60 text-success"></i>
                  </div>
                </div>
                <div class="col-7">
                  <div class="numbers">
                    <p class="card-category">Este Mes</p>
                    <p class="card-title trainer-number">{{ thisMonthEvaluations }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-lg-3 col-md-6">
          <div class="card card-stats trainer-stats-card">
            <div class="card-body">
              <div class="row">
                <div class="col-5">
                  <div class="icon-big text-center">
                    <i class="nc-icon nc-time-alarm text-warning"></i>
                  </div>
                </div>
                <div class="col-7">
                  <div class="numbers">
                    <p class="card-category">Pendientes</p>
                    <p class="card-title trainer-number">{{ pendingEvaluations }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-lg-3 col-md-6">
          <div class="card card-stats trainer-stats-card">
            <div class="card-body">
              <div class="row">
                <div class="col-5">
                  <div class="icon-big text-center">
                    <i class="nc-icon nc-chart-bar-32 text-info"></i>
                  </div>
                </div>
                <div class="col-7">
                  <div class="numbers">
                    <p class="card-category">Promedio Mejora</p>
                    <p class="card-title trainer-number">23%</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Plantillas de Evaluación -->
      <div class="row">
        <div class="col-12">
          <div class="card trainer-card">
            <div class="card-header">
              <h6 class="card-title">Plantillas de Evaluación</h6>
            </div>
            <div class="card-body">
              <div class="row">
                <div v-for="template in evaluationTemplates" :key="template.id" class="col-lg-4 col-md-6 mb-3">
                  <div class="trainer-template-card" @click="useTemplate(template)">
                    <div class="trainer-template-icon">
                      <i :class="template.icon"></i>
                    </div>
                    <div class="trainer-template-content">
                      <h6>{{ template.name }}</h6>
                      <p>{{ template.description }}</p>
                      <div class="trainer-template-meta">
                        <span class="badge badge-primary">{{ template.categories.length }} categorías</span>
                        <span class="badge badge-secondary">{{ template.duration }} min</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Lista de Evaluaciones -->
      <div class="row">
        <div class="col-12">
          <div class="card trainer-card">
            <div class="card-header">
              <div class="row align-items-center">
                <div class="col-md-6">
                  <h6 class="card-title">Evaluaciones Recientes</h6>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-6">
                      <select class="form-control form-control-sm" v-model="statusFilter">
                        <option value="">Todos los estados</option>
                        <option value="completada">Completadas</option>
                        <option value="pendiente">Pendientes</option>
                        <option value="programada">Programadas</option>
                      </select>
                    </div>
                    <div class="col-md-6">
                      <select class="form-control form-control-sm" v-model="typeFilter">
                        <option value="">Todos los tipos</option>
                        <option value="inicial">Inicial</option>
                        <option value="seguimiento">Seguimiento</option>
                        <option value="final">Final</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body p-0">
              <div class="table-responsive">
                <table class="table trainer-evaluations-table">
                  <thead>
                    <tr>
                      <th>Cliente</th>
                      <th>Tipo</th>
                      <th>Fecha</th>
                      <th>Estado</th>
                      <th>Progreso</th>
                      <th>Resultados</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="evaluation in filteredEvaluations" :key="evaluation.id">
                      <td>
                        <div class="trainer-client-info">
                          <img :src="evaluation.client.avatar" :alt="evaluation.client.name" class="trainer-client-avatar">
                          <div>
                            <strong>{{ evaluation.client.name }}</strong>
                            <br><small class="text-muted">{{ evaluation.client.goal }}</small>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span class="badge trainer-type-badge" :class="getTypeClass(evaluation.type)">
                          {{ getTypeLabel(evaluation.type) }}
                        </span>
                      </td>
                      <td>{{ formatDate(evaluation.date) }}</td>
                      <td>
                        <span class="badge trainer-status-badge" :class="getStatusClass(evaluation.status)">
                          {{ getStatusLabel(evaluation.status) }}
                        </span>
                      </td>
                      <td>
                        <div class="trainer-progress" v-if="evaluation.status === 'completada'">
                          <div class="progress">
                            <div 
                              class="progress-bar trainer-progress-bar" 
                              :style="{ width: evaluation.overallScore + '%' }"
                            ></div>
                          </div>
                          <span class="trainer-progress-text">{{ evaluation.overallScore }}%</span>
                        </div>
                        <span v-else class="text-muted">-</span>
                      </td>
                      <td>
                        <div v-if="evaluation.status === 'completada'" class="trainer-results-summary">
                          <i class="nc-icon nc-check-2 text-success" v-if="evaluation.improvements > 0" :title="`${evaluation.improvements} mejoras`"></i>
                          <i class="nc-icon nc-simple-remove text-warning" v-else-if="evaluation.improvements === 0" title="Sin cambios"></i>
                          <i class="nc-icon nc-minimal-down text-danger" v-else :title="`${Math.abs(evaluation.improvements)} áreas a mejorar`"></i>
                          <span class="ml-1">{{ evaluation.improvements > 0 ? '+' : '' }}{{ evaluation.improvements }}</span>
                        </div>
                        <span v-else class="text-muted">-</span>
                      </td>
                      <td>
                        <div class="trainer-actions">
                          <button v-if="evaluation.status === 'pendiente'" class="btn btn-sm btn-outline-primary" @click="startEvaluation(evaluation)">
                            <i class="nc-icon nc-settings-gear-65"></i>
                          </button>
                          <button v-if="evaluation.status === 'completada'" class="btn btn-sm btn-outline-success" @click="viewReport(evaluation)">
                            <i class="nc-icon nc-chart-bar-32"></i>
                          </button>
                          <button class="btn btn-sm btn-outline-info" @click="editEvaluation(evaluation)">
                            <i class="nc-icon nc-paper"></i>
                          </button>
                          <button class="btn btn-sm btn-outline-secondary" @click="duplicateEvaluation(evaluation)">
                            <i class="nc-icon nc-single-copy-04"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Análisis y Reportes -->
      <div class="row">
        <div class="col-lg-6">
          <div class="card trainer-card">
            <div class="card-header">
              <h6 class="card-title">Próximas Evaluaciones</h6>
            </div>
            <div class="card-body">
              <div class="trainer-upcoming-evaluations">
                <div v-for="upcoming in upcomingEvaluations" :key="upcoming.id" class="trainer-upcoming-item">
                  <div class="trainer-upcoming-date">
                    <strong>{{ upcoming.dayMonth }}</strong>
                    <br><small>{{ upcoming.time }}</small>
                  </div>
                  <div class="trainer-upcoming-client">
                    <img :src="upcoming.client.avatar" :alt="upcoming.client.name" class="trainer-upcoming-avatar">
                    <div>
                      <strong>{{ upcoming.client.name }}</strong>
                      <br><small>{{ upcoming.type }}</small>
                    </div>
                  </div>
                  <div class="trainer-upcoming-actions">
                    <button class="btn btn-sm btn-outline-primary">Preparar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-lg-6">
          <div class="card trainer-card">
            <div class="card-header">
              <h6 class="card-title">Resumen de Resultados</h6>
            </div>
            <div class="card-body">
              <div class="trainer-results-chart">
                <div class="trainer-metric-item">
                  <div class="trainer-metric-label">
                    <i class="nc-icon nc-chart-pie-36 text-primary"></i>
                    <span>Condición Cardiovascular</span>
                  </div>
                  <div class="trainer-metric-bar">
                    <div class="progress">
                      <div class="progress-bar bg-primary" style="width: 78%"></div>
                    </div>
                    <span class="trainer-metric-value">78%</span>
                  </div>
                </div>
                
                <div class="trainer-metric-item">
                  <div class="trainer-metric-label">
                    <i class="nc-icon nc-user-run text-success"></i>
                    <span>Fuerza Muscular</span>
                  </div>
                  <div class="trainer-metric-bar">
                    <div class="progress">
                      <div class="progress-bar bg-success" style="width: 85%"></div>
                    </div>
                    <span class="trainer-metric-value">85%</span>
                  </div>
                </div>
                
                <div class="trainer-metric-item">
                  <div class="trainer-metric-label">
                    <i class="nc-icon nc-settings-gear-65 text-warning"></i>
                    <span>Flexibilidad</span>
                  </div>
                  <div class="trainer-metric-bar">
                    <div class="progress">
                      <div class="progress-bar bg-warning" style="width: 65%"></div>
                    </div>
                    <span class="trainer-metric-value">65%</span>
                  </div>
                </div>
                
                <div class="trainer-metric-item">
                  <div class="trainer-metric-label">
                    <i class="nc-icon nc-chart-bar-32 text-info"></i>
                    <span>Composición Corporal</span>
                  </div>
                  <div class="trainer-metric-bar">
                    <div class="progress">
                      <div class="progress-bar bg-info" style="width: 72%"></div>
                    </div>
                    <span class="trainer-metric-value">72%</span>
                  </div>
                </div>
              </div>
              
              <div class="trainer-results-summary mt-4">
                <h6>Tendencias Generales</h6>
                <div class="row">
                  <div class="col-6">
                    <div class="trainer-trend-item">
                      <i class="nc-icon nc-minimal-up text-success"></i>
                      <span>Mejora promedio: +12%</span>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="trainer-trend-item">
                      <i class="nc-icon nc-chart-pie-36 text-info"></i>
                      <span>Adherencia: 87%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Nueva Evaluación -->
    <div class="modal" v-if="showNewEvaluationModal" @click="showNewEvaluationModal = false">
      <div class="modal-dialog modal-lg" @click.stop>
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Nueva Evaluación</h5>
            <button type="button" class="close" @click="showNewEvaluationModal = false">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Cliente</label>
                    <select class="form-control">
                      <option value="">Seleccionar cliente</option>
                      <option value="1">Ana Martínez</option>
                      <option value="2">Carlos Ruiz</option>
                      <option value="3">María González</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Tipo de Evaluación</label>
                    <select class="form-control">
                      <option value="inicial">Evaluación Inicial</option>
                      <option value="seguimiento">Seguimiento</option>
                      <option value="final">Evaluación Final</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Fecha Programada</label>
                    <input type="date" class="form-control">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Hora</label>
                    <input type="time" class="form-control">
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label>Plantilla</label>
                <select class="form-control">
                  <option value="">Seleccionar plantilla</option>
                  <option v-for="template in evaluationTemplates" :key="template.id" :value="template.id">
                    {{ template.name }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label>Objetivos de la Evaluación</label>
                <textarea class="form-control" rows="3" placeholder="Describir los objetivos específicos..."></textarea>
              </div>
              <div class="form-group">
                <label>Notas Adicionales</label>
                <textarea class="form-control" rows="2" placeholder="Información adicional relevante..."></textarea>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="showNewEvaluationModal = false">Cancelar</button>
            <button type="button" class="btn trainer-btn-primary" @click="createEvaluation">Programar Evaluación</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Evaluations',
  data() {
    return {
      showNewEvaluationModal: false,
      statusFilter: '',
      typeFilter: '',
      evaluationTemplates: [
        {
          id: 1,
          name: 'Evaluación Inicial Completa',
          description: 'Evaluación integral para nuevos clientes',
          icon: 'nc-icon nc-paper',
          categories: ['Antropometría', 'Cardio', 'Fuerza', 'Flexibilidad'],
          duration: 60
        },
        {
          id: 2,
          name: 'Test de Fuerza',
          description: 'Evaluación específica de fuerza muscular',
          icon: 'nc-icon nc-user-run',
          categories: ['1RM', 'Resistencia Muscular', 'Potencia'],
          duration: 45
        },
        {
          id: 3,
          name: 'Evaluación Cardiovascular',
          description: 'Tests de capacidad aeróbica y anaeróbica',
          icon: 'nc-icon nc-chart-pie-36',
          categories: ['VO2 Max', 'Frecuencia Cardíaca', 'Resistencia'],
          duration: 30
        },
        {
          id: 4,
          name: 'Composición Corporal',
          description: 'Análisis detallado de composición corporal',
          icon: 'nc-icon nc-chart-bar-32',
          categories: ['Peso', 'Grasa Corporal', 'Masa Muscular', 'Medidas'],
          duration: 30
        }
      ],
      evaluations: [
        {
          id: 1,
          client: {
            name: 'Ana Martínez',
            avatar: '/static/img/faces/ayo-ogunseinde-2.jpg',
            goal: 'Pérdida de peso'
          },
          type: 'inicial',
          date: '2024-01-15',
          status: 'completada',
          overallScore: 78,
          improvements: 3
        },
        {
          id: 2,
          client: {
            name: 'Carlos Ruiz',
            avatar: '/static/img/faces/erik-lucatero-2.jpg',
            goal: 'Ganancia de músculo'
          },
          type: 'seguimiento',
          date: '2024-01-18',
          status: 'completada',
          overallScore: 85,
          improvements: 2
        },
        {
          id: 3,
          client: {
            name: 'María González',
            avatar: '/static/img/faces/avatar.png',
            goal: 'Mejora de condición'
          },
          type: 'inicial',
          date: '2024-01-20',
          status: 'pendiente',
          overallScore: null,
          improvements: null
        },
        {
          id: 4,
          client: {
            name: 'José López',
            avatar: '/static/img/faces/erik-lucatero-2.jpg',
            goal: 'Rehabilitación'
          },
          type: 'seguimiento',
          date: '2024-01-22',
          status: 'programada',
          overallScore: null,
          improvements: null
        }
      ],
      upcomingEvaluations: [
        {
          id: 1,
          dayMonth: '20 Ene',
          time: '10:00',
          client: {
            name: 'María González',
            avatar: '/static/img/faces/avatar.png'
          },
          type: 'Evaluación Inicial'
        },
        {
          id: 2,
          dayMonth: '22 Ene',
          time: '15:30',
          client: {
            name: 'José López',
            avatar: '/static/img/faces/erik-lucatero-2.jpg'
          },
          type: 'Test de Seguimiento'
        }
      ]
    }
  },
  computed: {
    thisMonthEvaluations() {
      // Simular evaluaciones del mes actual
      return this.evaluations.filter(evaluation => {
        const evalDate = new Date(evaluation.date);
        const now = new Date();
        return evalDate.getMonth() === now.getMonth() && evalDate.getFullYear() === now.getFullYear();
      }).length;
    },
    pendingEvaluations() {
      return this.evaluations.filter(evaluation => 
        evaluation.status === 'pendiente' || evaluation.status === 'programada'
      ).length;
    },
    filteredEvaluations() {
      let filtered = this.evaluations;
      
      if (this.statusFilter) {
        filtered = filtered.filter(evaluation => evaluation.status === this.statusFilter);
      }
      
      if (this.typeFilter) {
        filtered = filtered.filter(evaluation => evaluation.type === this.typeFilter);
      }
      
      return filtered.sort((a, b) => new Date(b.date) - new Date(a.date));
    }
  },
  methods: {
    getTypeClass(type) {
      const classes = {
        'inicial': 'badge-primary',
        'seguimiento': 'badge-info',
        'final': 'badge-success'
      };
      return classes[type] || 'badge-secondary';
    },
    getTypeLabel(type) {
      const labels = {
        'inicial': 'Inicial',
        'seguimiento': 'Seguimiento',
        'final': 'Final'
      };
      return labels[type] || type;
    },
    getStatusClass(status) {
      const classes = {
        'completada': 'badge-success',
        'pendiente': 'badge-warning',
        'programada': 'badge-info'
      };
      return classes[status] || 'badge-secondary';
    },
    getStatusLabel(status) {
      const labels = {
        'completada': 'Completada',
        'pendiente': 'Pendiente',
        'programada': 'Programada'
      };
      return labels[status] || status;
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('es-ES');
    },
    useTemplate(template) {
      this.showNewEvaluationModal = true;
      this.$swal.fire({
        title: 'Plantilla Seleccionada',
        text: `Usando plantilla: ${template.name}`,
        icon: 'success',
        confirmButtonColor: '#9ACD32'
      });
    },
    startEvaluation(evaluation) {
      this.$swal.fire({
        title: 'Iniciar Evaluación',
        text: `Iniciar evaluación para ${evaluation.client.name}`,
        confirmButtonColor: '#9ACD32'
      });
    },
    viewReport(evaluation) {
      this.$swal.fire({
        title: 'Reporte de Evaluación',
        text: `Ver reporte completo de ${evaluation.client.name}`,
        confirmButtonColor: '#9ACD32'
      });
    },
    editEvaluation(evaluation) {
      this.$swal.fire({
        title: 'Editar Evaluación',
        text: `Editar evaluación de ${evaluation.client.name}`,
        confirmButtonColor: '#9ACD32'
      });
    },
    duplicateEvaluation(evaluation) {
      this.$swal.fire({
        title: 'Evaluación Duplicada',
        text: `Se ha creado una copia de la evaluación`,
        icon: 'success',
        confirmButtonColor: '#9ACD32'
      });
    },
    createEvaluation() {
      this.showNewEvaluationModal = false;
      this.$swal.fire({
        title: 'Evaluación Programada',
        text: 'La evaluación ha sido programada exitosamente',
        icon: 'success',
        confirmButtonColor: '#9ACD32'
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  --trainer-primary: #9ACD32;
  --trainer-secondary: #7CB342;
  --trainer-accent: #8BC34A;
  --trainer-dark: #689F38;
  --trainer-light: #DCEDC8;
  --trainer-bg: #F1F8E9;
}

.trainer-evaluations-header {
  background: linear-gradient(135deg, var(--trainer-primary), var(--trainer-secondary));
  color: white;
  border: none;
  box-shadow: 0 4px 20px 0px rgba(154, 205, 50, 0.14), 0 7px 10px -5px rgba(154, 205, 50, 0.4);
  
  .trainer-card-header {
    background: transparent;
    border: none;
  }
  
  .trainer-title {
    color: white;
    font-weight: 500;
    margin-bottom: 5px;
    
    i {
      margin-right: 10px;
    }
  }
  
  .trainer-subtitle {
    color: rgba(255,255,255,0.8);
    margin: 0;
  }
  
  .trainer-btn-new {
    border: 2px solid rgba(255,255,255,0.3);
    color: white;
    
    &:hover {
      background: rgba(255,255,255,0.1);
      border-color: rgba(255,255,255,0.5);
    }
  }
}

.trainer-card {
  border: none;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  margin-bottom: 20px;
  
  .card-header {
    background: var(--trainer-bg);
    border-bottom: 1px solid #dee2e6;
    
    .card-title {
      color: var(--trainer-dark);
      font-weight: 600;
      margin: 0;
    }
  }
}

.trainer-stats-card {
  border: none;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 5px 25px 0 rgba(0,0,0,0.15);
    transform: translateY(-2px);
  }
  
  .trainer-number {
    font-size: 24px;
    font-weight: 700;
    color: var(--trainer-dark);
  }
}

.trainer-template-card {
  background: white;
  border: 2px solid var(--trainer-light);
  border-radius: 8px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  height: 100%;
  
  &:hover {
    border-color: var(--trainer-primary);
    box-shadow: 0 5px 15px rgba(154, 205, 50, 0.1);
    transform: translateY(-3px);
  }
  
  .trainer-template-icon {
    text-align: center;
    margin-bottom: 15px;
    
    i {
      font-size: 36px;
      color: var(--trainer-primary);
    }
  }
  
  .trainer-template-content {
    text-align: center;
    
    h6 {
      color: var(--trainer-dark);
      font-weight: 600;
      margin-bottom: 10px;
    }
    
    p {
      color: #666;
      font-size: 14px;
      margin-bottom: 15px;
      line-height: 1.4;
    }
    
    .trainer-template-meta {
      display: flex;
      justify-content: center;
      gap: 8px;
      
      .badge {
        font-size: 11px;
        padding: 4px 8px;
      }
    }
  }
}

.trainer-evaluations-table {
  .trainer-client-info {
    display: flex;
    align-items: center;
    
    .trainer-client-avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 12px;
      object-fit: cover;
    }
  }
  
  .trainer-progress {
    display: flex;
    align-items: center;
    gap: 10px;
    
    .progress {
      flex: 1;
      height: 8px;
      background: #e9ecef;
      border-radius: 4px;
      
      .trainer-progress-bar {
        background: var(--trainer-primary);
        border-radius: 4px;
      }
    }
    
    .trainer-progress-text {
      font-size: 12px;
      font-weight: 600;
      color: var(--trainer-dark);
      min-width: 35px;
    }
  }
  
  .trainer-type-badge,
  .trainer-status-badge {
    font-size: 11px;
    padding: 4px 8px;
  }
  
  .trainer-results-summary {
    display: flex;
    align-items: center;
    font-size: 14px;
    
    i {
      font-size: 16px;
    }
  }
  
  .trainer-actions {
    display: flex;
    gap: 5px;
    
    .btn {
      padding: 4px 8px;
      font-size: 12px;
    }
  }
}

.trainer-upcoming-evaluations {
  .trainer-upcoming-item {
    display: flex;
    align-items: center;
    padding: 15px;
    background: #f8f9fa;
    border-radius: 6px;
    margin-bottom: 15px;
    
    .trainer-upcoming-date {
      text-align: center;
      margin-right: 15px;
      min-width: 80px;
      
      strong {
        color: var(--trainer-primary);
        font-size: 16px;
      }
      
      small {
        color: #666;
      }
    }
    
    .trainer-upcoming-client {
      display: flex;
      align-items: center;
      flex: 1;
      
      .trainer-upcoming-avatar {
        width: 35px;
        height: 35px;
        border-radius: 50%;
        margin-right: 10px;
        object-fit: cover;
      }
    }
    
    .trainer-upcoming-actions {
      .btn {
        font-size: 12px;
        padding: 4px 12px;
      }
    }
  }
}

.trainer-results-chart {
  .trainer-metric-item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    
    .trainer-metric-label {
      display: flex;
      align-items: center;
      min-width: 180px;
      margin-right: 15px;
      
      i {
        font-size: 18px;
        margin-right: 8px;
      }
      
      span {
        font-size: 14px;
        color: var(--trainer-dark);
      }
    }
    
    .trainer-metric-bar {
      display: flex;
      align-items: center;
      flex: 1;
      
      .progress {
        flex: 1;
        height: 10px;
        margin-right: 10px;
      }
      
      .trainer-metric-value {
        font-size: 14px;
        font-weight: 600;
        color: var(--trainer-dark);
        min-width: 40px;
      }
    }
  }
}

.trainer-results-summary {
  .trainer-trend-item {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    
    i {
      font-size: 16px;
      margin-right: 8px;
    }
    
    span {
      font-size: 14px;
    }
  }
}

.trainer-btn-primary {
  background: var(--trainer-primary);
  border-color: var(--trainer-primary);
  color: white;
  
  &:hover {
    background: var(--trainer-secondary);
    border-color: var(--trainer-secondary);
  }
}

.form-control {
  border: 2px solid #e9ecef;
  border-radius: 6px;
  
  &:focus {
    border-color: var(--trainer-primary);
    box-shadow: 0 0 0 0.2rem rgba(154, 205, 50, 0.25);
  }
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  
  .modal-dialog {
    background: white;
    border-radius: 8px;
    max-width: 90%;
    max-height: 90%;
    overflow-y: auto;
  }
  
  .modal-header {
    padding: 20px;
    border-bottom: 1px solid #dee2e6;
    
    .modal-title {
      color: var(--trainer-dark);
      font-weight: 600;
    }
    
    .close {
      background: none;
      border: none;
      font-size: 24px;
      line-height: 1;
      color: #999;
      cursor: pointer;
    }
  }
  
  .modal-body {
    padding: 20px;
  }
  
  .modal-footer {
    padding: 20px;
    border-top: 1px solid #dee2e6;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
}
</style>